"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobileDetection_1 = require("../utils/mobileDetection");
var WelcomeView = function (_a) {
    var onSelectChat = _a.onSelectChat, onSelectCall = _a.onSelectCall;
    var isMobile = (0, mobileDetection_1.useIsMobile)();
    return (react_1.default.createElement("div", { style: {
            padding: isMobile ? 16 : 20,
            display: "flex",
            flexDirection: "column",
            gap: isMobile ? 12 : 16,
        } },
        react_1.default.createElement("div", { style: { display: "flex", justifyContent: "flex-start" } },
            react_1.default.createElement("img", { src: "assets/Fermaglo_Image01.png", alt: "Brandmark", width: 48, height: 48, style: {
                    objectFit: "contain",
                    borderRadius: 10,
                    background: "#F8FAFC",
                    boxShadow: "0 0 0 1px rgba(0,0,0,0.06) inset",
                } })),
        react_1.default.createElement("div", { style: {
                fontSize: isMobile ? 20 : 22,
                fontWeight: 800,
                color: "#111827",
            } }, "Hi There!"),
        react_1.default.createElement("div", { style: { fontSize: isMobile ? 13 : 14, color: "#6B7280" } }, "We are delighted to help you"),
        react_1.default.createElement("button", { onClick: onSelectChat, style: {
                width: "100%",
                padding: isMobile ? "10px 16px" : "12px 18px",
                borderRadius: 999,
                background: "#572c5d",
                color: "#fff",
                fontWeight: 700,
                fontSize: isMobile ? 14 : 15,
                cursor: "pointer",
                border: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 10,
            } },
            react_1.default.createElement("span", { style: { fontSize: 18 } },
                react_1.default.createElement("img", { src: "assets/Icon_ChatWithUs.svg", width: 20, style: {
                        objectFit: "contain",
                    } })),
            "Chat With Us"),
        react_1.default.createElement("button", { onClick: onSelectCall, style: {
                width: "100%",
                padding: isMobile ? "10px 16px" : "12px 18px",
                borderRadius: 999,
                background: "#fff",
                color: "#5B21B6",
                fontWeight: 700,
                fontSize: isMobile ? 14 : 15,
                cursor: "pointer",
                border: "1px solid #5B21B6",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 10,
            } },
            react_1.default.createElement("span", { style: { fontSize: 16 } },
                react_1.default.createElement("img", { src: "assets/Icon_CallUs.svg", width: 20, style: {
                        objectFit: "contain",
                    } })),
            " ",
            "Call Us")));
};
exports.default = WelcomeView;
